module.exports = __webpack_public_path__ + "img/logo2.d2f6468f.png";